import React from 'react';
import './ManageShows.css'

const  ContextMenu=(props)=>{
    
    const deleteAction=async(id)=>{
        props.onDeleteClick(id);
    }
    const editAction=async(id)=>{
        props.onEditClick();
    }

    return(
    <>
    <div className='card-column-auto'>
        <div className='adaction-list'>
            <ul>
                <li><button type='button' onClick={() => deleteAction(props.id)} >Delete</button></li>
                <li><button type='button' onClick={() => editAction(props.id)}>Edit</button></li>
            </ul>
        </div>
    </div>
    </>
    )
}

export default ContextMenu;